import Joi from 'joi';
import PropTypes from 'prop-types';

import Form from '../../common/form';

class VIRemarkItemForm extends Form {
	state = { data: { remark: '' }, errors: {}, loading: false, progress: 0 };

	static propTypes = {
		onAddRemark: PropTypes.func.isRequired,
	};

	schema = {
		remark: Joi.string()
			.min(10)
			.required()
			.label('Remarks & Recommendation / Action(s) Taken'),
	};

	doSubmit = () => {
		this.props.onAddRemark(this.state.data.remark);

		const data = { ...this.state.data };
		data.remark = '';

		this.setState({ data });
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit} className="my-4">
				<div className="row">
					<div className="col-10">
						{this.renderInput({
							type: 'text',
							name: 'remark',
							placeholder: 'Enter Remark',
							label: 'Remarks & Recommendation / Action(s) Taken',
						})}
					</div>

					<div className="col">{this.renderButton('Add Remark')}</div>
				</div>
			</form>
		);
	}
}

export default VIRemarkItemForm;
